export default class DeckController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    //get model
    const model = this.getModel();

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
    const items = app.items;

    let coins = userdata.coins || 0;
    let fullVersion = userdata.fullVersion;
    let ownedItems = userdata.items || [];
    let itemsAll = items.allItems.filter(i => i.type === "Deck");
    let itemsModel = itemsAll.map((i) => {
      let owned = ownedItems.includes(i.name);
      if (i.cost === 0 || fullVersion == true) owned = true;
      return {
        name: i.name,
        icon: i.icon,
        title: i.title,
        owned: owned,
        locked: !owned,
        cost: i.cost,
        url: i.url,
        background: i.background,
        codeOnly: i.codeOnly
      };
    });
    let model = {
      coins: coins,
      items: itemsModel
    }
   return model;
  }
  
}